import type { ListControlProps } from '../../declare'
import { Switch } from 'antd'

const SwitchControl = (props: ListControlProps) => {
  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  return (
    <Switch checked={props.value} onChange={handleChange} />
  )
}

export default SwitchControl